export const isNonEmpty = v => typeof v==='string' && v.trim().length>0;
export const uniqueName = (name,existing)=> !existing.some(w=>w.name.toLowerCase()===name.trim().toLowerCase());
